import { HTMLViewer } from '@consigli/facade';
import { type FC } from 'react';

import type { DocumentPaneRenderProps } from '@aecom-ai-engineering/react-components';

interface HtmlRendererPaneProps {
  active: boolean;
  src: DocumentPaneRenderProps['src'];
}

const HtmlRendererPane: FC<HtmlRendererPaneProps> = ({ active, src }) => {
  if (!active) return null;

  const fileUrl = typeof src === 'string' ? src : src instanceof URL ? src.href : undefined;
  if (!fileUrl) return null;

  return (
    <div className="h-full w-full bg-white">
      <HTMLViewer fileUrl={fileUrl} />
    </div>
  );
};

export function createHtmlRenderer() {
  return function HtmlRenderer(props: DocumentPaneRenderProps) {
    return <HtmlRendererPane active={props.active} src={props.src} />;
  };
}
